import styled from 'styled-components/macro'
import Typography from '@material-ui/core/Typography'

const EmptyMageListHint = styled(Typography)`
  margin-top: 24px;
`

EmptyMageListHint.displayName = 'EmptyMageListHint'

export default EmptyMageListHint
